// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2ic9V","footer":"Form_footer__2atxZ"};